import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// import Question from "../../TestPassage/question";
// import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
// import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import cache from "memory-cache";
import { Popover, Typography } from "@material-ui/core";
import { WEB_URL } from "../../../utils/constants";
import onWindowReload from '../../../utils/reloadFunction';
const useStyles = makeStyles((theme) => ({
  root: {
    display :"flex",
    borderRadius: "15px",
    border:"2px solid #6f2981 ",
    width: "15px",
    height: "15px",
    position:"relative",
    visibility:"visible",
    top:"0px",
    left:"-15px",
    padding:"10px", 
    textAlign:"justify",
  },
  icon: {
    display:'none',
    borderRadius: "15px",
    border:"1px solid #6f2981 ",
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
      background:"#fff",
      backgroundColor: "#fff",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    display:"flex",
    top:"-15px",
    left:"-6px",
    padding:"3px",
    borderRadius: "15px",
    background:"#6f2981",
    border:"2px solid #fff",
    backgroundImage:
      "radial-gradient(#fff,#fff 28%,transparent 32%)",
    "&:before": {
      display: "block",
      width: "15px",
      height:"15px",
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
  },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding:'0px 5px',
  },
}));

export default (props) => {
  const classes = useStyles();
  // const theme = useTheme();
  const {
    testData,
    questionNo,
    setClearFlag,
    clearFlag,
    examId,
    setCheckFlag,
    examDetail,
    answerStatus,
    setAnswerStatus,
    // disable,
    setDisable,
    setTestData,
    windowSwitchCount,setWindowSwitch
  } = props;

  const optionData = testData && testData[questionNo - 1]
  const currentQueOption = {choiceid : optionData.choiceid.split("|^^|"), label:optionData.choicetext.split("|^^|")}
  
  const [selectAnswer, setAnswer] = React.useState(""); //testData[questionNo -1].choicetext.split('|^^|')[testData[questionNo -1].choiceid.split('|^^|').indexOf(testData[questionNo -1].selectedChoiceId)]
  
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  onWindowReload(examId,examDetail,setWindowSwitch,setTestData,windowSwitchCount,testData)

  const open = Boolean(anchorEl);
  const getAnswer = (event) => {
    if(event.target.value){
    setClearFlag(false);
    setCheckFlag(true);
    setAnswer(event.target.value);
    let idx = currentQueOption.choiceid.indexOf(event.target.value)
    testData[questionNo - 1].selectedChoiceId = currentQueOption.choiceid[idx];
    
   
    // testData[questionNo - 1].selectedChoiceId = testData[
    //   questionNo - 1
    // ].choicetext.split("|^^|")[
    //   testData[questionNo - 1].choiceid
    //     .split("|^^|")
    //     .indexOf(event.target.value)
    // ];
   
   
    let temp = answerStatus;
    //temp[questionNo -1] = (testData[questionNo -1].choiceid.split('|^^|')[testData[questionNo -1].choicetext.split('|^^|').indexOf(event.target.value)] === testData[questionNo -1].correctid) ? testData[questionNo -1].qmarks : 0;
    setAnswerStatus(temp);
    // testData[questionNo - 1].answerStatus =
    //   testData[questionNo - 1].choiceid.split("|^^|")[
    //     testData[questionNo - 1].choicetext
    //       .split("|^^|")
    //       .indexOf(event.target.value)
    //   ] === testData[questionNo - 1].correctid
    //     ? true
    //     : false;
    testData[questionNo -1].answerStatus = testData[questionNo -1].selectedChoiceId === testData[questionNo -1].correctid ? true : false; 


    testData[questionNo - 1].buttonStyle = "Answered";
    let collectData = {quesData: testData, examDetail: examDetail}
    let encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))))
    window.localStorage.setItem(examId, encode);
    }
  };

  const shuffle = (array) => {
    let i = array.length,
      j = 0,
      temp;
    while (i--) {
      j = Math.floor(Math.random() * (i + 1));
      temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  };

  React.useEffect(() => {
   
    if (questionNo === testData.length) {
      

      setDisable(true);
    }
    setAnswer(
     (testData[questionNo - 1].selectedChoiceId)
    );
    
//     setAnswer(testData[questionNo - 1].choicetext.split("|^^|")[
//       testData[questionNo - 1].choiceid
//         .split("|^^|")
//         .indexOf(testData[questionNo - 1].selectedChoiceId)
//     ]
// )
// const toTop = () => {
//   console.log('HERE');
//   // window.scrollBy({
//   //     top: 0,
//   //     behavior: "smooth"
//   //   });
//   document.body.scrollTop = 0;
//   // document.documentElement.scrollTop = 0;
// };
    if (clearFlag) {
      testData[questionNo - 1].selectedChoiceId = "";
      // toTop();
      setAnswer("");
      let temp = answerStatus;
      //temp[questionNo -1] = 0;
      setAnswerStatus(temp);
      testData[questionNo - 1].buttonStyle = "Not Answered";
      let collectData = {quesData: testData, examDetail: examDetail}
      let encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))))
      window.localStorage.setItem(examId, encode);
      
      setClearFlag(false);
    }
  }); //,[selectAnswer]

  const StyledRadio = (props) => {
    const classes = useStyles();
    return (
      <Radio
        className={classes.root}
        disableRipple
        color="#fff"
        checkedIcon={
          selectAnswer !== " " && selectAnswer !== undefined ? (
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          ) : (
            <span className={classes.icon} />
          )
        }
        icon={<span className={classes.icon} />}
        {...props}
        // onClick={() => getAnswer(props.value)}
        onClick={getAnswer}
      />
    );
  };

  return (
   <>
      <div className="form-group">
        <label>
          { (questionNo === 'Undefined') ?
          <>
              <Typography
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
           <span className="question-num" >
            Q . {testData[questionNo - 1].passageQuestionNo} of {testData.length}
          </span>  
            </Typography>
              <Popover
              id="mouse-over-popover"
              className={classes.popover}
              classes={{
                paper: classes.paper,
              }}
              // PaperProps={{
              //   style: { height: '4%',textAlign:"center"},
              // }}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
            >
              <h5>{testData[questionNo -1].qid}</h5>
            </Popover> 
         </>
          :
          <>
          <Typography
          aria-owns={open ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
        <span className="question-num">Q.{questionNo} of {testData.length}</span>
                
        </Typography>
          {/* <Button> Question No {questionNo}</Button>< br/>  */}
          <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          // PaperProps={{
          //   style: { height: '4%',textAlign:"center"},
          // }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <h5>{testData[questionNo -1].qid}</h5>
        </Popover> 
       </> 
              }
              {examDetail[0].comprehensionflag && testData[questionNo - 1].passageheader  ?  
          <span dangerouslySetInnerHTML={{__html:testData[questionNo - 1].passageheader }}/> :
          <span dangerouslySetInnerHTML={{__html:testData[questionNo - 1].qtext }} />}
        </label>
      </div>
      <div className={!examDetail[0].comprehensionflag && testData[questionNo -1].passagetext  ? "row ":"row paraque-box"}>
      {examDetail[0].comprehensionflag && testData[questionNo -1].passagetext ?
        <div className="col-md-6">
          <p>
            <b>Passage</b>
          </p>
          <div className="question-para" style={{fontSize: '16px',textAlign: 'justify'}}>
          <span  dangerouslySetInnerHTML={{__html: testData[questionNo -1].passagetext}} />
          </div>
          {/* Need to check here (Dhaval) */}
          {testData[questionNo - 1].passageImage && testData[questionNo - 1].passageImage.indexOf("/null") === -1 ?
           //style={{float: window.in nerWidth < 1000 ? null : 'right',top: window.innerWidth < 1000 ? '-50px' : '-110px'}}
               
            <img className="img-responsive" src={`${WEB_URL}`+testData[questionNo -1].passageImage.replace('${process.env.WEB_URL}','')} style={{width:window.innerWidth < 1000 ? "300px" : " ",height:window.innerWidth < 1000 ? "auto" : ""}} alt="Graph..." /> 
                : ''
            }
        </div>
        : testData[questionNo -1].qresourcepath !== '' ?
                 <div className="col-md-6">
                      <> 
                        <img className="img-responsive" src={`${WEB_URL}ah-resources/questionimages/`+testData[questionNo -1].qresourcepath.split('|^^|')[0]}  />
                        </>
                        </div>
                        : <></>

                 }

            
        <div className={examDetail[0].comprehensionflag ?  "col-md-6": examDetail[0].instancename === "Multi Choice Single Correct" ? "col-md-12" : "col-md-6"} style={{width: !examDetail[0].comprehensionflag && testData[questionNo -1].questiontypename === 'Multiple Choice Single Correct' && testData[questionNo -1].qresourcepath === '' && '100%', paddingTop: !examDetail[0].comprehensionflag && testData[questionNo -1].questiontypename === 'Multiple Choice Single Correct' && testData[questionNo -1].qresourcepath === '' && '20px'}}>
        {examDetail[0].comprehensionflag  && testData[questionNo -1].passagetext? <p><b>Question</b></p>:" "}
          <div className="form-group question-right">
          {examDetail[0].comprehensionflag && testData[questionNo -1].passagetext ? 
          <>
            
            <label className="control-label">
              
            <span dangerouslySetInnerHTML={{__html:testData[questionNo - 1].qtext }} /></label> 
            </>:<></>}
            
                        <FormControl component="fieldset"
                        style={{display:'block'}}
                        >
                            
                        <RadioGroup
                            defaultValue="options"
                            aria-label="options"
                            name="customized-radios"
                            
                        >
                          {/* {testData[questionNo -1].choicetext.split('|^^|').map((item,index) => 
                            (
                            <FormControlLabel
                            value={item}
                            key={index}
                            control={<StyledRadio />}
                            style={{ color: testData[questionNo -1].choicetext.split('|^^|')[testData[questionNo -1].choiceid.split('|^^|').indexOf(testData[questionNo -1].selectedChoiceId)] === item ? '#fff' : '#525252'}}
                            label={<><span className="mr-3" dangerouslySetInnerHTML={{__html: item}} style={{color:testData[questionNo -1].choicetext.split('|^^|')[testData[questionNo -1].choiceid.split('|^^|').indexOf(testData[questionNo -1].selectedChoiceId)] === item  ? "#fff" : "#525252" }} />
                            {testData[questionNo -1].chresourcepath !== "" ? <img style={{marginLeft:"15px"}} src={`${WEB_URL}ah-resources/questionimages/`+testData[questionNo -1].chresourcepath.split('|^^|')[index]}/>:""}</>
                          }
                            checked={testData[questionNo -1].choicetext.split('|^^|')[testData[questionNo -1].choiceid.split('|^^|').indexOf(testData[questionNo -1].selectedChoiceId)] === item  ? true : false}
                            className={testData[questionNo -1].choicetext.split('|^^|')[testData[questionNo -1].choiceid.split('|^^|').indexOf(testData[questionNo -1].selectedChoiceId)] === item  ? "radio checked" : "radio"}
                        
                            />
                          ))
                        
                        } */}
                {currentQueOption.choiceid.map((item, index) =>
                 (
                   <>
                  <FormControlLabel
                    value={item}
                    key={index}
                    control={<StyledRadio />}
                    style={{ color: testData[questionNo - 1].selectedChoiceId === item ? '#fff' : '#525252' }}
                    label={<><span className="mr-3" dangerouslySetInnerHTML={{ __html: currentQueOption.label[index] }} style={{ color: testData[questionNo - 1].selectedChoiceId === item ? "#fff" : "#525252" }} />
                      {testData[questionNo - 1].chresourcepath !== "" ? <img style={{ marginLeft: "15px" }} src={`${WEB_URL}ah-resources/questionimages/` + testData[questionNo - 1].chresourcepath.split('|^^|')[index]} /> : ""}</>
                    }
                    checked={testData[questionNo - 1].selectedChoiceId === item ? true : false}
                    className={testData[questionNo - 1].selectedChoiceId === item ? "radio checked" : "radio"}       
                  />
                  </>
                  )
                  )

                }
                     
                      </RadioGroup>
                      </FormControl>
            </div>
        </div>
        </div>
    </>
  );
};

